import { PropAsset } from './PropAsset';

// Barrel - Fıçı
// TODO: Replace with SVG asset
export class Barrel extends PropAsset {
  readonly id = 'barrel';
  readonly width = 22;
  readonly height = 28;
  readonly walkable = false;
  readonly collisionRadius = 0.4;

  draw(ctx: CanvasRenderingContext2D, cx: number, cy: number, s: number, _variant?: number): void {
    // Shadow
    ctx.fillStyle = 'rgba(0,0,0,0.15)';
    ctx.beginPath();
    ctx.ellipse(cx, cy - 2 * s, 8 * s, 4 * s, 0, 0, Math.PI * 2);
    ctx.fill();

    // Barrel body - Fıçı gövdesi
    ctx.fillStyle = '#6b5335';

    // Draw barrel shape (wider in middle)
    ctx.beginPath();
    ctx.moveTo(cx - 6 * s, cy - 2 * s);
    ctx.quadraticCurveTo(cx - 8 * s, cy - 10 * s, cx - 6 * s, cy - 18 * s);
    ctx.lineTo(cx + 6 * s, cy - 18 * s);
    ctx.quadraticCurveTo(cx + 8 * s, cy - 10 * s, cx + 6 * s, cy - 2 * s);
    ctx.closePath();
    ctx.fill();

    // Metal bands - Metal bantlar
    ctx.fillStyle = '#4a4a4a';
    ctx.fillRect(cx - 7.5 * s, cy - 17 * s, 15 * s, 2 * s);
    ctx.fillRect(cx - 8 * s, cy - 11 * s, 16 * s, 2 * s);
    ctx.fillRect(cx - 7.5 * s, cy - 5 * s, 15 * s, 2 * s);

    // Top - Üst
    ctx.fillStyle = '#5b4325';
    ctx.beginPath();
    ctx.ellipse(cx, cy - 18 * s, 6 * s, 3 * s, 0, 0, Math.PI * 2);
    ctx.fill();

    // Wood grain highlight - Ahşap doku
    ctx.strokeStyle = 'rgba(255,255,255,0.1)';
    ctx.lineWidth = 1 * s;
    ctx.beginPath();
    ctx.moveTo(cx - 2 * s, cy - 17 * s);
    ctx.lineTo(cx - 2 * s, cy - 3 * s);
    ctx.stroke();
  }
}
